var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dragAndDrop",rawName:"v-dragAndDrop:state",value:(_vm.state),expression:"state",arg:"state"}],staticClass:"trello-drag-container",on:{"onDrop":_vm.onDropHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }